import {IScrollspyMenuItems, ScrollspyMenu} from '@/partials/menu';

const SidebarModalMenu = () => {
    const items: IScrollspyMenuItems = [
        {
            title: 'You can add information by',
            children: [
                {
                    title: 'Upload Document',
                    target: 'upload_document',
                    //active: true
                },
                {
                    title: 'Copy & Paste',
                    target: 'upload_text',
                },
                {
                    title: 'Webpage',
                    target: 'crawl_webpage',
                },
            ]
        },
        {
            title: 'Other Sources',
            children: [
                {
                    title: 'LinkedIn',
                    target: 'crawl_linkedin',
                },
            ]
        },

    ];

    return <ScrollspyMenu items={items}/>;
};

export {SidebarModalMenu};
